/**
 * #logger.ts
 *
 * Code generated by ts-proto. DO NOT EDIT.
 * @packageDocumentation
 */
/* eslint-disable */
import _m0 from "protobufjs/minimal.js";
import { map } from "rxjs/operators";
import { Timestamp } from "../../../google/protobuf/timestamp.js";
import { StringValue, UInt32Value } from "../../../google/protobuf/wrappers.js";
import { messageTypeRegistry } from "../../../typeRegistry.js";
export var Severity;
(function (Severity) {
    /**
     * DEBUG - Debug logs should never be committed.
     *
     * These logs are always enabled in development builds but disabled in
     * production.
     */
    Severity[Severity["DEBUG"] = 0] = "DEBUG";
    /**
     * INFO - Informational logs should be used to mark significant non-erroneous events.
     * Little information is significant.
     *
     * These logs are enabled by default in development builds but may be
     * disabled in production.
     */
    Severity[Severity["INFO"] = 1] = "INFO";
    /**
     * WARN - Warnings should be reported as long as they do not contain sensitive data.
     *
     * These logs are always enabled.
     */
    Severity[Severity["WARN"] = 2] = "WARN";
    /**
     * ERROR - Errors should always be reported as long as they do not contain sensitive
     * data.
     */
    Severity[Severity["ERROR"] = 3] = "ERROR";
    /**
     * VERBOSE - Verbose logs are useful for tracing but usually a hindrance for others not
     * working where the log is placed. Keep our logs clean and add with care.
     *
     * These logs are disabled by default in all environments but can be enabled.
     */
    Severity[Severity["VERBOSE"] = 4] = "VERBOSE";
    Severity[Severity["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Severity || (Severity = {}));
export function severityFromJSON(object) {
    switch (object) {
        case 0:
        case "DEBUG":
            return Severity.DEBUG;
        case 1:
        case "INFO":
            return Severity.INFO;
        case 2:
        case "WARN":
            return Severity.WARN;
        case 3:
        case "ERROR":
            return Severity.ERROR;
        case 4:
        case "VERBOSE":
            return Severity.VERBOSE;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Severity.UNRECOGNIZED;
    }
}
export function severityToJSON(object) {
    switch (object) {
        case Severity.DEBUG:
            return 0;
        case Severity.INFO:
            return 1;
        case Severity.WARN:
            return 2;
        case Severity.ERROR:
            return 3;
        case Severity.VERBOSE:
            return 4;
        case Severity.UNRECOGNIZED:
        default:
            return -1;
    }
}
function createBaseLogErrorMessage() {
    return {
        message: "",
        name: "",
        fileName: undefined,
        lineNumber: undefined,
        columnNumber: undefined,
        stack: undefined,
        timestamp: undefined,
        tags: [],
    };
}
export const LogErrorMessage = {
    $type: "devvit.plugin.logger.LogErrorMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.message !== "") {
            writer.uint32(10).string(message.message);
        }
        if (message.name !== "") {
            writer.uint32(18).string(message.name);
        }
        if (message.fileName !== undefined) {
            StringValue.encode({ value: message.fileName }, writer.uint32(26).fork()).ldelim();
        }
        if (message.lineNumber !== undefined) {
            UInt32Value.encode({ value: message.lineNumber }, writer.uint32(34).fork()).ldelim();
        }
        if (message.columnNumber !== undefined) {
            UInt32Value.encode({ value: message.columnNumber }, writer.uint32(42).fork()).ldelim();
        }
        if (message.stack !== undefined) {
            StringValue.encode({ value: message.stack }, writer.uint32(50).fork()).ldelim();
        }
        if (message.timestamp !== undefined) {
            Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(58).fork()).ldelim();
        }
        for (const v of message.tags) {
            writer.uint32(66).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogErrorMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.name = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.fileName = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.lineNumber = UInt32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.columnNumber = UInt32Value.decode(reader, reader.uint32()).value;
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.stack = StringValue.decode(reader, reader.uint32()).value;
                    continue;
                case 7:
                    if (tag !== 58) {
                        break;
                    }
                    message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 8:
                    if (tag !== 66) {
                        break;
                    }
                    message.tags.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            name: isSet(object.name) ? globalThis.String(object.name) : "",
            fileName: isSet(object.fileName) ? String(object.fileName) : undefined,
            lineNumber: isSet(object.lineNumber) ? Number(object.lineNumber) : undefined,
            columnNumber: isSet(object.columnNumber) ? Number(object.columnNumber) : undefined,
            stack: isSet(object.stack) ? String(object.stack) : undefined,
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.name !== "") {
            obj.name = message.name;
        }
        if (message.fileName !== undefined) {
            obj.fileName = message.fileName;
        }
        if (message.lineNumber !== undefined) {
            obj.lineNumber = message.lineNumber;
        }
        if (message.columnNumber !== undefined) {
            obj.columnNumber = message.columnNumber;
        }
        if (message.stack !== undefined) {
            obj.stack = message.stack;
        }
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.tags?.length) {
            obj.tags = message.tags;
        }
        return obj;
    },
    create(base) {
        return LogErrorMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogErrorMessage();
        message.message = object.message ?? "";
        message.name = object.name ?? "";
        message.fileName = object.fileName ?? undefined;
        message.lineNumber = object.lineNumber ?? undefined;
        message.columnNumber = object.columnNumber ?? undefined;
        message.stack = object.stack ?? undefined;
        message.timestamp = object.timestamp ?? undefined;
        message.tags = object.tags?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(LogErrorMessage.$type, LogErrorMessage);
function createBaseLogEventMessage() {
    return { type: "", timestamp: undefined, labels: {}, data: {} };
}
export const LogEventMessage = {
    $type: "devvit.plugin.logger.LogEventMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.type !== "") {
            writer.uint32(10).string(message.type);
        }
        if (message.timestamp !== undefined) {
            Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(18).fork()).ldelim();
        }
        Object.entries(message.labels).forEach(([key, value]) => {
            LogEventMessage_LabelsEntry.encode({ key: key, value }, writer.uint32(26).fork()).ldelim();
        });
        Object.entries(message.data).forEach(([key, value]) => {
            LogEventMessage_DataEntry.encode({ key: key, value }, writer.uint32(34).fork()).ldelim();
        });
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogEventMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.type = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    const entry3 = LogEventMessage_LabelsEntry.decode(reader, reader.uint32());
                    if (entry3.value !== undefined) {
                        message.labels[entry3.key] = entry3.value;
                    }
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    const entry4 = LogEventMessage_DataEntry.decode(reader, reader.uint32());
                    if (entry4.value !== undefined) {
                        message.data[entry4.key] = entry4.value;
                    }
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            type: isSet(object.type) ? globalThis.String(object.type) : "",
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            labels: isObject(object.labels)
                ? Object.entries(object.labels).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
            data: isObject(object.data)
                ? Object.entries(object.data).reduce((acc, [key, value]) => {
                    acc[key] = String(value);
                    return acc;
                }, {})
                : {},
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.type !== "") {
            obj.type = message.type;
        }
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.labels) {
            const entries = Object.entries(message.labels);
            if (entries.length > 0) {
                obj.labels = {};
                entries.forEach(([k, v]) => {
                    obj.labels[k] = v;
                });
            }
        }
        if (message.data) {
            const entries = Object.entries(message.data);
            if (entries.length > 0) {
                obj.data = {};
                entries.forEach(([k, v]) => {
                    obj.data[k] = v;
                });
            }
        }
        return obj;
    },
    create(base) {
        return LogEventMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogEventMessage();
        message.type = object.type ?? "";
        message.timestamp = object.timestamp ?? undefined;
        message.labels = Object.entries(object.labels ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        message.data = Object.entries(object.data ?? {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = globalThis.String(value);
            }
            return acc;
        }, {});
        return message;
    },
};
messageTypeRegistry.set(LogEventMessage.$type, LogEventMessage);
function createBaseLogEventMessage_LabelsEntry() {
    return { key: "", value: "" };
}
export const LogEventMessage_LabelsEntry = {
    $type: "devvit.plugin.logger.LogEventMessage.LabelsEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogEventMessage_LabelsEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return LogEventMessage_LabelsEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogEventMessage_LabelsEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
messageTypeRegistry.set(LogEventMessage_LabelsEntry.$type, LogEventMessage_LabelsEntry);
function createBaseLogEventMessage_DataEntry() {
    return { key: "", value: "" };
}
export const LogEventMessage_DataEntry = {
    $type: "devvit.plugin.logger.LogEventMessage.DataEntry",
    encode(message, writer = _m0.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogEventMessage_DataEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            key: isSet(object.key) ? globalThis.String(object.key) : "",
            value: isSet(object.value) ? globalThis.String(object.value) : "",
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.key !== "") {
            obj.key = message.key;
        }
        if (message.value !== "") {
            obj.value = message.value;
        }
        return obj;
    },
    create(base) {
        return LogEventMessage_DataEntry.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogEventMessage_DataEntry();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
messageTypeRegistry.set(LogEventMessage_DataEntry.$type, LogEventMessage_DataEntry);
function createBaseLogMessage() {
    return { severity: 0, message: "", timestamp: undefined, tags: [] };
}
export const LogMessage = {
    $type: "devvit.plugin.logger.LogMessage",
    encode(message, writer = _m0.Writer.create()) {
        if (message.severity !== 0) {
            writer.uint32(8).int32(message.severity);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        if (message.timestamp !== undefined) {
            Timestamp.encode(toTimestamp(message.timestamp), writer.uint32(26).fork()).ldelim();
        }
        for (const v of message.tags) {
            writer.uint32(34).string(v);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.severity = reader.int32();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.timestamp = fromTimestamp(Timestamp.decode(reader, reader.uint32()));
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.tags.push(reader.string());
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            severity: isSet(object.severity) ? severityFromJSON(object.severity) : 0,
            message: isSet(object.message) ? globalThis.String(object.message) : "",
            timestamp: isSet(object.timestamp) ? fromJsonTimestamp(object.timestamp) : undefined,
            tags: globalThis.Array.isArray(object?.tags) ? object.tags.map((e) => globalThis.String(e)) : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.severity !== 0) {
            obj.severity = severityToJSON(message.severity);
        }
        if (message.message !== "") {
            obj.message = message.message;
        }
        if (message.timestamp !== undefined) {
            obj.timestamp = message.timestamp.toISOString();
        }
        if (message.tags?.length) {
            obj.tags = message.tags;
        }
        return obj;
    },
    create(base) {
        return LogMessage.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogMessage();
        message.severity = object.severity ?? 0;
        message.message = object.message ?? "";
        message.timestamp = object.timestamp ?? undefined;
        message.tags = object.tags?.map((e) => e) || [];
        return message;
    },
};
messageTypeRegistry.set(LogMessage.$type, LogMessage);
function createBaseLogMessages() {
    return { messages: [] };
}
export const LogMessages = {
    $type: "devvit.plugin.logger.LogMessages",
    encode(message, writer = _m0.Writer.create()) {
        for (const v of message.messages) {
            LogMessage.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogMessages();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.messages.push(LogMessage.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(object) {
        return {
            messages: globalThis.Array.isArray(object?.messages)
                ? object.messages.map((e) => LogMessage.fromJSON(e))
                : [],
        };
    },
    toJSON(message) {
        const obj = {};
        if (message.messages?.length) {
            obj.messages = message.messages.map((e) => LogMessage.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return LogMessages.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseLogMessages();
        message.messages = object.messages?.map((e) => LogMessage.fromPartial(e)) || [];
        return message;
    },
};
messageTypeRegistry.set(LogMessages.$type, LogMessages);
function createBaseLogErrorResponse() {
    return {};
}
export const LogErrorResponse = {
    $type: "devvit.plugin.logger.LogErrorResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogErrorResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return LogErrorResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseLogErrorResponse();
        return message;
    },
};
messageTypeRegistry.set(LogErrorResponse.$type, LogErrorResponse);
function createBaseLogEventResponse() {
    return {};
}
export const LogEventResponse = {
    $type: "devvit.plugin.logger.LogEventResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogEventResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return LogEventResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseLogEventResponse();
        return message;
    },
};
messageTypeRegistry.set(LogEventResponse.$type, LogEventResponse);
function createBaseLogResponse() {
    return {};
}
export const LogResponse = {
    $type: "devvit.plugin.logger.LogResponse",
    encode(_, writer = _m0.Writer.create()) {
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLogResponse();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    fromJSON(_) {
        return {};
    },
    toJSON(_) {
        const obj = {};
        return obj;
    },
    create(base) {
        return LogResponse.fromPartial(base ?? {});
    },
    fromPartial(_) {
        const message = createBaseLogResponse();
        return message;
    },
};
messageTypeRegistry.set(LogResponse.$type, LogResponse);
export const LoggerServiceName = "devvit.plugin.logger.Logger";
export class LoggerClientImpl {
    constructor(rpc, opts) {
        this.service = opts?.service || LoggerServiceName;
        this.rpc = rpc;
        this.Error = this.Error.bind(this);
        this.Event = this.Event.bind(this);
        this.Log = this.Log.bind(this);
        this.LogBatch = this.LogBatch.bind(this);
        this.LogStream = this.LogStream.bind(this);
    }
    Error(request, metadata) {
        const data = LogErrorMessage.encode(request).finish();
        const promise = this.rpc.request(this.service, "Error", data, metadata);
        return promise.then((data) => LogErrorResponse.decode(_m0.Reader.create(data)));
    }
    Event(request, metadata) {
        const data = LogEventMessage.encode(request).finish();
        const promise = this.rpc.request(this.service, "Event", data, metadata);
        return promise.then((data) => LogEventResponse.decode(_m0.Reader.create(data)));
    }
    Log(request, metadata) {
        const data = LogMessage.encode(request).finish();
        const promise = this.rpc.request(this.service, "Log", data, metadata);
        return promise.then((data) => LogResponse.decode(_m0.Reader.create(data)));
    }
    LogBatch(request, metadata) {
        const data = LogMessages.encode(request).finish();
        const promise = this.rpc.request(this.service, "LogBatch", data, metadata);
        return promise.then((data) => LogResponse.decode(_m0.Reader.create(data)));
    }
    LogStream(request, metadata) {
        const data = request.pipe(map((request) => LogMessage.encode(request).finish()));
        const promise = this.rpc.clientStreamingRequest(this.service, "LogStream", data, metadata);
        return promise.then((data) => LogResponse.decode(_m0.Reader.create(data)));
    }
}
export const LoggerDefinition = {
    name: "Logger",
    fullName: "devvit.plugin.logger.Logger",
    methods: {
        error: {
            name: "Error",
            requestType: LogErrorMessage,
            requestStream: false,
            responseType: LogErrorResponse,
            responseStream: false,
            options: {},
        },
        /**
         * Record a notable event or historical record for analytics and security.
         *
         * @internal
         * Deprecated 2026-02-13: hasn't been used in a long time, callers removed.
         *
         * @deprecated
         */
        event: {
            name: "Event",
            requestType: LogEventMessage,
            requestStream: false,
            responseType: LogEventResponse,
            responseStream: false,
            options: {},
        },
        log: {
            name: "Log",
            requestType: LogMessage,
            requestStream: false,
            responseType: LogResponse,
            responseStream: false,
            options: {},
        },
        logBatch: {
            name: "LogBatch",
            requestType: LogMessages,
            requestStream: false,
            responseType: LogResponse,
            responseStream: false,
            options: {},
        },
        /**
         * Send log messages in a stream rather than unary calls.
         * This can be useful for guaranteeing ordering of received log messages.
         */
        logStream: {
            name: "LogStream",
            requestType: LogMessage,
            requestStream: true,
            responseType: LogResponse,
            responseStream: false,
            options: {},
        },
    },
};
function toTimestamp(date) {
    const seconds = Math.trunc(date.getTime() / 1000);
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = (t.seconds || 0) * 1000;
    millis += (t.nanos || 0) / 1000000;
    return new globalThis.Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof globalThis.Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new globalThis.Date(o);
    }
    else {
        return fromTimestamp(Timestamp.fromJSON(o));
    }
}
function isObject(value) {
    return typeof value === "object" && value !== null;
}
function isSet(value) {
    return value !== null && value !== undefined;
}
